import { render, staticRenderFns } from "./UserVip.vue?vue&type=template&id=17b09293&"
import script from "./UserVip.vue?vue&type=script&lang=js&"
export * from "./UserVip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports